import modalManager from 'modules/modalManager';
import proNotifications from 'modules/proNotifications';

import WelcomeMessageModal from 'components/provider/modals/WelcomeMessageModal';

import './Notification.scss';

/**
 * Welcome notification
 */
export default function WelcomeNotification() {
  const notification = {
    type: 'welcome',
    title: 'Welcome to your notifications feed',
    message: 'This is where you\'ll get real-time updates about your business, \
      like when clients book or cancel appointments. When there\'s \
      a new update in your feed, you\'ll see a red bubble over your home tab.',
    creation_time: moment().toISOString(),
  };

  /**
   * Open the welcome message modal
   */
  const openModal = () => {
    modalManager.openModal(WelcomeMessageModal, {
      notification,
    });
    proNotifications.trackNotificationClick(notification);
  };

  return (
    <button
      onClick={openModal}
      className="button-notification"
    >
      <section className="notification">
        <div className="icon">
          <div className="styleseat-logo" />
        </div>
        <section className="notification-body short-block">
          <p className="notification-text short-text-ellipsis">
            <strong>
              {notification.title}.
            </strong>
            <span>
              {` ${notification.message} `}
            </span>
          </p>
          <span className="from-now">{proNotifications.getFromNowDisplay(notification.creation_time)}</span>
        </section>
      </section>
    </button>
  );
}

WelcomeNotification.propTypes = {};
